// =================
// Parameters Module
// =================

import axios from '@/axios';

export function setupParametersModule(i18n)
{
    return {
        namespaced: true,

        // ------------------------------------------------------------------------- STATE

        state:
        {
            propertiesByPrototype: {},
            attributesByParameter: {},
        },

        // ------------------------------------------------------------------------- GETTERS

        getters:
        {
            getFormatters: state => parameterCode => state.attributesByParameter[parameterCode]?.formatters || null,

            getAttribute: state => (parameterCode, attributeCode) =>
            {
                const attributes = state.attributesByParameter[parameterCode];

                if(attributes)
                {
                    return attributes[attributeCode];
                }

                return null;
            },

            getProperty: state => (prototypeCode, parameterCode, propertyCode) =>
            {
                const parameters = state.propertiesByPrototype[prototypeCode];

                if(parameters)
                {
                    const parameter = parameters[parameterCode];

                    if(parameter)
                    {
                        return parameter[propertyCode];
                    }
                }

                return null;
            },
        },

        // ------------------------------------------------------------------------- MUTATIONS

        mutations:
        {
            setProperties(state, propertiesByPrototype)
            {
                state.propertiesByPrototype = propertiesByPrototype;
            },

            setAttributes(state, attributesByParameter)
            {
                state.attributesByParameter = attributesByParameter;
            },

            setTranslations(state, translations)
            {
                i18n.global.mergeLocaleMessage(i18n.global.locale.value, { parameters: translations });
            },
        },

        // ------------------------------------------------------------------------- MUTATIONS

        actions:
        {
            async fetchGlobalProperties({ commit, rootState })
            {
                const url = '/api/parameters/properties/:eid'
                    .replace(':eid', rootState.account.cEntity.id);

                try
                {
                    const { data } = await axios.get(url);
                    commit('setProperties', data);
                }
                catch(error)
                {
                    console.log(error);
                }
            },

            async fetchAttributes({ commit })
            {
                try
                {
                    const { data } = await axios.get('/api/parameters/attributes');
                    commit('setAttributes', data);
                }
                catch(error)
                {
                    console.log(error);
                }
            },

            async fetchTranslations({ commit })
            {
                try
                {
                    const { data } = await axios.get('/api/parameters/translations');
                    commit('setTranslations', data.parameters);
                    return data;
                }
                catch(error)
                {
                    console.log(error);
                    throw error;
                }
            },
        },
    };
};
